// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ElementosDocumentosPdf_DeleteResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for DELETE /config/elementos_documentos_pdf/delete/{name}.
 *
 * The external html2pdf micro-service `DELETE page_elements/{name}` handler
 * (services/html2pdf-service/src/server/pageelement.go) returns
 * `Envia_dados_json(c, true)` on success — i.e. `Dados: true`. The model
 * (documentos_model::deletePageElement) forwards `$resultado->Dados`
 * verbatim, so the success-path dados is always a boolean.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ElementosDocumentosPdf_DeleteResponseDados = boolean;

export type ElementosDocumentosPdf_DeleteResponse = ApiResponse<ElementosDocumentosPdf_DeleteResponseDados>;

registerResponseContract('ElementosDocumentosPdf_DeleteResponse', {})
